import { fetcher } from '../utils'
import { ComponentClientContactVO } from '@repo/types'

export default async (input: ComponentClientContactVO): Promise<void> =>
  fetcher(`/api/relationship/client/new/contact`, 'POST', input)
